import { authCredentials as auth, apiUrl } from '@/api/apiConfig';
import axios from 'axios';

const createTestData = async (data) => {
  try {
    const response = await axios({
      method: 'post',
      url: `${apiUrl}/tests/`,
      data: { input: data },
      headers: auth,
    });
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

const createTestInfo = async (data) => {
  try {
    const response = await axios({
      method: 'post',
      url: `${apiUrl}/info`,
      data: { input: data },
      headers: auth,
    });
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export {
  createTestData,
  createTestInfo,
};
